
import log from 'loglevel';

const handleAdminStatusChange = (e, dispatch) => {
  log.debug('handle change of options -> ', e.target.value);
  if(e.target.value === '0'){
    // user is Admin.
    dispatch({
      type: 'ADD_ADMIN_STATUS',
      payload: true,
    })
  } else {
    // user is not Admin, and making request on behalf of the Admin.
    // user is Admin.
    dispatch({
      type: 'ADD_ADMIN_STATUS',
      payload: false,
    })
  }
}

export default handleAdminStatusChange;